import { Button } from '@imgly/imgly-website-components';
import { Link } from 'gatsby';
import * as React from 'react';
import { ReactComponent as StackBlitz } from '../../../../../assets/images/imgly/stackblitz.svg';
import { ReactComponent as GitHubLogo } from '../../../../../assets/images/imgly/github.svg';
import {
  codeButtonsItem,
  codeButtonsList,
  githubButton
} from './code_buttons.module.css';

function buildStackBlitzUrl(
  githubPath,
  option = {
    title: null,
    file: null
  }
) {
  const stackBlitzParams = new URLSearchParams({
    title: option.title,
    file: option.file
  });
  return `https://stackblitz.com/fork/github/${githubPath}?${stackBlitzParams.toString()}`;
}

const CodeButtons = ({
  githubPath,
  showCodesandbox = true,
  includeText = false
}) => {
  const version = process.env.GATSBY_CESDK_VERSION;
  // replace VERSION with the actual version
  const fullGithubPath = githubPath.replace('VERSION', `v${version}`);
  // Title should be the last segment of the url title-cased, e.g for https://github.com/imgly/cesdk-web-examples/tree/v1.20.0/integrate-with-vanilla-js it should be Integrate With Vanilla Js
  const exampleTitle = fullGithubPath
    .split('/')
    .pop()
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (l) => l.toUpperCase());
  const title = `IMG.LY's CE.SDK: ${exampleTitle}`;

  const githubUrl = `https://github.com/${fullGithubPath}`;
  const stackBlitzUrl = buildStackBlitzUrl(fullGithubPath, {
    title,
    // By default we want to open a file called index.js
    file: 'index.js'
  });
  return (
    <>
      {includeText && !showCodesandbox && (
        <p>
          <span>Explore a full code sample on&nbsp;</span>
          <Link to={githubUrl}>Github&nbsp;</Link>
          <span>.</span>
        </p>
      )}
      {includeText && showCodesandbox && (
        <p>
          <span>Explore a full code sample on&nbsp;</span>
          <Link to={stackBlitzUrl}>Stackblitz&nbsp;</Link>
          <span>or view the code on&nbsp;</span>
          <Link to={githubUrl}>Github</Link>.
        </p>
      )}

      <ul className={codeButtonsList}>
        {showCodesandbox && (
          <li className={codeButtonsItem}>
            <Button
              render={<a />}
              href={stackBlitzUrl}
              rel="noreferrer"
              target="_blank"
              leadingIcon={<StackBlitz />}
              small
            >
              Edit on Stackblitz
            </Button>
          </li>
        )}
        <li className={codeButtonsItem}>
          <Button
            className={githubButton}
            render={<a />}
            href={githubUrl}
            rel="noreferrer"
            target="_blank"
            leadingIcon={<GitHubLogo />}
            small
          >
            View on GitHub
          </Button>
        </li>
      </ul>
    </>
  );
};
export default CodeButtons;
